<template>
	<div class="component-navigator-bar-side flex flex-nowrap justify-end items-center bm-row bm-gx-6">
		<!-- 未登陆用户 -->
		<!-- @TODO 这里不直接展示，先做一些判断 -->
		<template v-if="!isLogined">
			<SensorTrack
				class="bm-col flex-grow-0 hidden bmmd:block"
				:datas="{
					sensorEventName: 'ClickTopBar',
					module_name: '登录',
					button_name: '登录',
				}"
			>
				<nuxt-link-enhance
					class="item flex items-center whitespace-nowrap cursor-pointer hover:bm-text-effect"
					:class="[size]"
					project="www"
					:to="computedLoginRoute"
					exact
				>
					{{ $t('bmui-navigator-bar.common_sign_in') }}
				</nuxt-link-enhance>
			</SensorTrack>

			<SensorTrack
				class="bm-col flex-grow-0 hidden bmmd:block"
				:datas="{
					sensorEventName: 'ClickTopBar',
					module_name: '注册',
					button_name: '注册',
				}"
			>
				<nuxt-link-enhance
					class="register-btn relative flex justify-center items-center h-10 px-6 whitespace-nowrap cursor-pointer text-center text-sm rounded hover:bm-bg-effect-300 active:bm-bg-effect-600"
					:class="[size]"
					project="www"
					:to="computedRegisterRoute"
					exact
				>
					{{ $t('bmui-navigator-bar.common_register') }}
				</nuxt-link-enhance>
			</SensorTrack>
		</template>

		<template v-if="isLogined">
			<DropdownMenuPicker
				class="bm-col flex-grow-0 hidden bm2xl:block"
				:size="size"
				:reference="$t('bmui-navigator-bar.auth_route_assets')"
				:list="assetsConfig"
				:show-indicator="false"
			/>

			<DropdownMenuPicker
				class="bm-col flex-grow-0 hidden bm2xl:block"
				:size="size"
				:reference="$t('bmui-navigator-bar.auth_route_orders')"
				:list="ordersConfig"
				:show-indicator="false"
			/>

			<DropdownAccountPanel class="bm-col flex-grow-0 hidden bmmd:block" :size="size" :theme="theme" :avatar="true" />
		</template>
		<DropdownMessagePanel class="bm-col flex-grow-0 hidden bmmd:block" :size="size" placement="bottom-end" />
		<!-- 二维码下载 -->
		<DropdownMenuPicker class="bm-col flex-grow-0 hidden bmxl:block" :size="size" placement="bottom-end">
			<svg
				class="svgfont"
				version="1.1"
				xmlns="http://www.w3.org/2000/svg"
				width="512"
				height="512"
				viewBox="0 0 512 512"
			>
				<path
					fill="currentColor"
					d="M468.922 413.538l-27.842-27.842-50.926 50.922v-160.926h-39.385v160.926l-50.926-50.922-27.842 27.842 98.462 98.462 98.462-98.462z"
				/>
				<path
					fill="currentColor"
					d="M114.462 472.615v-354.462h236.307v98.462h39.385v-177.231c-0.013-10.441-4.166-20.453-11.547-27.835-7.385-7.383-17.395-11.537-27.837-11.55h-236.307c-10.442 0.010-20.454 4.162-27.838 11.546s-11.537 17.395-11.546 27.838v433.231c0.011 10.442 4.166 20.451 11.549 27.837 7.383 7.382 17.394 11.535 27.835 11.547h118.153v-39.385h-118.153zM114.462 39.385h236.307v39.384h-236.307v-39.385z"
				/>
			</svg>
			<template #content>
				<AppQRCode class="p-4" />
			</template>
		</DropdownMenuPicker>
		<!-- 语言选择 -->
		<client-only>
			<DropdownLanguagePicker class="bm-col flex-grow-0 hidden bmxl:block" :size="size" placement="bottom-end" />
			<template #fallback>
				<span class="bm-col flex-grow-0 hidden bmxl:block" />
			</template>
		</client-only>

		<ThemeSwitcher
			class="bm-col flex-grow-0 h-full items-center cursor-pointer hidden bmxl:flex"
			v-if="showThemeSwitcher"
		/>

		<TradeSetting
			v-if="showSetting"
			class="trade-setting bm-col flex-grow-0 h-full items-center cursor-pointer hidden bmxl:flex"
			:setting="setting"
			:size="size"
			@onChange="handleSettingChange"
		>
			<svg
				class="svgfont flex items-center cursor-pointer whitespace-nowrap hover:bm-text-effect small"
				version="1.1"
				xmlns="http://www.w3.org/2000/svg"
				width="512"
				height="512"
				viewBox="0 0 512 512"
			>
				<path
					d="M457.618 269.936v-28.049l35.208-30.807c7.643-6.754 12.438-16.579 12.438-27.524 0-7.123-2.031-13.772-5.545-19.399l0.090 0.155-43.306-73.35c-6.447-11.019-18.212-18.309-31.683-18.337h-0.004c-0.070-0.001-0.154-0.001-0.237-0.001-4.112 0-8.067 0.677-11.757 1.925l0.259-0.076-44.597 15.022c-6.767-4.582-14.627-9.159-22.789-13.216l-1.211-0.544-9.36-46.211c-3.459-16.95-18.247-29.523-35.971-29.523-0.248 0-0.495 0.003-0.741 0.007l0.036-0.001h-85.82c-0.209-0.004-0.457-0.007-0.704-0.007-17.725 0-32.512 12.572-35.931 29.287l-0.040 0.236-9.359 46.211c-8.362 4.049-16.43 8.656-24.206 13.76l-43.629-15.755c-2.788-0.76-5.989-1.197-9.291-1.197-0.86 0-1.713 0.030-2.558 0.088l0.114-0.007c-13.498 0.005-25.29 7.302-31.653 18.165l-0.094 0.173-43.277 73.35c-3.127 5.285-4.974 11.648-4.974 18.442 0 10.982 4.826 20.835 12.473 27.557l0.041 0.036 34.651 31.716v28.049l-34.651 30.807c-7.857 6.766-12.802 16.726-12.802 27.841 0 6.993 1.957 13.527 5.353 19.089l-0.091-0.161 43.277 73.351c6.456 11.035 18.249 18.332 31.745 18.337h0.001c3.99 0.029 7.922-0.587 11.736-1.849l44.538-15.022c7.716 5.106 15.726 9.683 24.059 13.76l9.331 46.211c3.459 16.95 18.247 29.523 35.971 29.523 0.248 0 0.494-0.002 0.741-0.007l-0.036 0h86.554c0.209 0.005 0.457 0.007 0.704 0.007 17.724 0 32.512-12.572 35.931-29.287l0.040-0.236 9.36-46.211c8.362-4.049 16.43-8.656 24.205-13.76l44.362 15.022c3.474 1.204 7.479 1.898 11.646 1.898 13.536 0 25.358-7.333 31.713-18.242l0.094-0.175 41.81-73.322c3.133-5.289 4.985-11.658 4.985-18.459 0-10.972-4.818-20.82-12.454-27.54l-0.041-0.035-34.651-31.716zM424.786 402.701l-62.877-21.272c-14.108 12.007-30.592 21.76-48.577 28.418l-1.125 0.365-13.027 65.839h-86.553l-13.027-65.106c-18.993-7.237-35.38-16.963-49.767-29.002l0.269 0.219-63.082 20.538-43.277-73.351 49.879-44.010c-1.617-8.627-2.542-18.553-2.542-28.695s0.925-20.067 2.695-29.697l-0.153 1.002-49.879-45.302 43.277-73.35 62.877 21.271c14.108-12.007 30.593-21.758 48.578-28.418l1.125-0.365 13.027-65.84h86.553l13.027 65.106c18.993 7.237 35.38 16.963 49.767 29.002l-0.269-0.22 63.082-20.538 43.277 73.35-49.879 44.011c3.404 18.983 3.404 38.436 0 57.389l49.879 45.301-43.277 73.351z"
				></path>
				<path
					d="M255.903 366.025c-60.766 0-110.025-49.26-110.025-110.025s49.26-110.025 110.025-110.025c60.766 0 110.025 49.26 110.025 110.025v0c0.003 0.315 0.005 0.688 0.005 1.061 0 60.183-48.787 108.969-108.969 108.969-0.373 0-0.746-0.002-1.118-0.005l0.056 0zM255.903 182.649c-0.495-0.012-1.078-0.019-1.662-0.019-39.603 0-71.707 32.105-71.707 71.707 0 0.584 0.007 1.167 0.020 1.748l-0.001-0.087c-0.012 0.495-0.019 1.078-0.019 1.663 0 39.603 32.105 71.707 71.707 71.707 0.584 0 1.167-0.007 1.749-0.021l-0.087 0.002c0.495 0.012 1.078 0.019 1.662 0.019 39.603 0 71.707-32.104 71.707-71.707 0-0.584-0.007-1.168-0.021-1.749l0.002 0.087c0.012-0.495 0.019-1.078 0.019-1.662 0-39.603-32.104-71.707-71.707-71.707-0.584 0-1.168 0.007-1.749 0.020l0.087-0.001z"
				></path>
			</svg>
		</TradeSetting>
		<!-- 移动端抽屉按钮 -->
		<DrawerNavigator
			class="bm-col flex-grow-0 bmxl:hidden"
			:size="size"
			:project="project"
			:common-routes-config="commonRoutesConfig"
		/>
	</div>
</template>

<script>
import commonMixins from '../mixins';

import { AUTH_ROUTES_MAP, PROJECT_MAP } from '../config';
import SensorTrack from './SensorTrack';
import DropdownMenuPicker from './DropdownMenuPicker';
import AppQRCode from './AppQRCode';
import DropdownLanguagePicker from './DropdownLanguagePicker';
import DropdownAccountPanel from './DropdownAccountPanel';
import DrawerNavigator from './DrawerNavigator';
import NuxtLinkEnhance from './NuxtLinkEnhance';
import ThemeSwitcher from './ThemeSwitcher';
import TradeSetting from '../../TradeSetting/index.vue';
import DropdownMessagePanel from './message/DropdownMessagePanel.vue';
import { isLoginedToken } from '~/common/js/utils';
import { usePatchStore } from '~/common/js/patch';

export default {
	name: 'ComponentNavigatorBarSide',
	components: {
		DropdownAccountPanel,
		AppQRCode,
		DropdownMenuPicker,
		ThemeSwitcher,
		DrawerNavigator,
		DropdownLanguagePicker,
		SensorTrack,
		NuxtLinkEnhance,
		TradeSetting,
		DropdownMessagePanel
	},

	mixins: [commonMixins],
	props: {
		// 皮肤切换按钮
		showThemeSwitcher: {
			type: Boolean,
			default: false,
		},
		// 设置按钮
		showSetting: {
			type: Boolean,
			default: false,
		},
		setting: {
			type: Object,
		},
		size: {
			type: String,
			default: '',
		},
		theme: {
			type: String,
			default: '',
		},
		project: {
			type: String,
			default: PROJECT_MAP.MASTER,
		},
		commonRoutesConfig: {
			type: Array,
			default() {
				return [];
			},
		},
	},
	data() {
		return {
			name: '',
			isLogined: false,
		};
	},
	computed: {
		locale() {
			return this.store.locale;
		},
		// @TODO userName的取值要改一下
		userName() {
			return this.store.account.loginName;
		},
		kycLevel() {
			return this.store.kycLevel;
		},
		isSubAccount() {
			return this.getters('account/isSubAccount');
		},
		// ...mapState({
		// 	locale: (state) => state.locale,
		// 	userName: (state) => state.account.loginName,
		// 	kycLevel: (state) => +state.account.kycLevel,
		// }),
		// ...mapGetters({
		// 	// 是否子账户
		// 	isSubAccount: 'account/isSubAccount',
		// }),
		assetsConfig() {
			return [
				{ show: true, ...AUTH_ROUTES_MAP.get('ASSETS.OVERVIEW') },
				{ show: true, ...AUTH_ROUTES_MAP.get('ASSETS.SPOT') },
				{ show: !this.isSubAccount, ...AUTH_ROUTES_MAP.get('ASSETS.MARGIN') },
				{ show: true, ...AUTH_ROUTES_MAP.get('ASSETS.FUTURES') },
				{ show: !this.isSubAccount, ...AUTH_ROUTES_MAP.get('ASSETS.EARN') },
				{ show: !this.isSubAccount, ...AUTH_ROUTES_MAP.get('ASSETS.BUYSELL') },
				{ show: !this.isSubAccount && this.kycLevel === 10, ...AUTH_ROUTES_MAP.get('ASSETS.CREDIT') },
				{ show: !this.isSubAccount, ...AUTH_ROUTES_MAP.get('ASSETS.FUNDS') },
			];
		},
		ordersConfig() {
			return [
				{ show: true, ...AUTH_ROUTES_MAP.get('ORDER.SPOT') },
				{ show: !this.isSubAccount, ...AUTH_ROUTES_MAP.get('ORDER.MARGIN') },
				{ show: true, ...AUTH_ROUTES_MAP.get('ORDER.FUTURES') },
				{ show: true, ...AUTH_ROUTES_MAP.get('ORDER.EARN') },
				{ show: true, ...AUTH_ROUTES_MAP.get('ORDER.BUYSELL') },
			];
		},
		computedLoginRoute() {
			// 如果当前路由地址是是合约赠金活动(/bonus-giveaway)，则使用不同的路由地址，GIVEAWAY_INVITE
			// @TODO 后续同学改造一下，用map形式
			const currentRouteName = this.$route.name;

			if (currentRouteName === 'login-lang') {
				return {
					path: '/login',
					query: {
						inviteType: this.$route.query.inviteType,
					},
				};
			} else {
				return {
					path: '/login',
				};
			}
		},
		computedRegisterRoute() {
			// 如果当前路由地址是是合约赠金活动(/bonus-giveaway)，则使用不同的路由地址，GIVEAWAY_INVITE
			const currentRouteName = this.$route.name;

			if (currentRouteName === 'login-lang') {
				return {
					path: '/register',
					query: {
						inviteType: this.$route.query.inviteType,
					},
				};
			} else {
				return {
					path: '/register',
				};
			}
		},
	},
	methods: {
		handleSettingChange(data) {
			this.$emit('onSettingChange', data);
		},
	},
	mounted() {
		this.isLogined = isLoginedToken();
		// @TODO 对于userName的逻辑获取需要进行优化
		// this.name = process.client ? Cookies.get('userName') : null;
	},
	setup() {
		const { store, getters } = usePatchStore();
		return {
			store,
			getters,
		};
	},
	watch: {
		userName(v) {
			if (v) {
				this.isLogined = isLoginedToken();
			}
		},
	},
};
</script>

<style lang="less" scoped>
@import '../assets/css/ui.variables.less';

.component-navigator-bar-side {
	flex: 1 0 auto;

	.item {
		height: @navigator_bar_height;
		&.small {
			height: @navigator_bar_height_small;
		}
		&.medium {
			height: @navigator_bar_height_medium;
		}
	}

	.register-btn {
		position: relative;
		box-sizing: border-box;
		min-width: 68px;
		background-color: @effect_color;
		color: @white_color;
	}

	.trade-setting {
		// background-color: @white_color;
		svg.small {
			height: 56px;
		}
	}

	.svgfont {
		font-size: 16px;
	}

	.menu-mobile {
		display: none;
	}

	.avatar {
		width: 24px;
		height: 24px;
	}
}
</style>
